/*  iceberg-ui  */
import { Icon } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { ToggleButton } from '@mui/material';

/* Shared */
import { DarkTooltip } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/* Internal */
import { ManagedTableSelectColumnsV2 } from './ManagedTableSelectColumnsV2';

export const ManagedTableShowHideColumns = () => {
    const { t } = useTranslation();
    const [openColumnSelection, setOpenColumnSelection] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const showHideColumnHandleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenColumnSelection(true);
    };

    const showHideColumnHandleClose = () => {
        setAnchorEl(null);
        setOpenColumnSelection(false);
    };

    return (
        <>
            <DarkTooltip
                arrow
                placement="left"
                title={t('Tooltips.showHideColumns')}
            >
                <ToggleButton
                    aria-label="open toggle column selection"
                    value="check"
                    selected={openColumnSelection}
                    onChange={(event) => showHideColumnHandleClick(event)}
                >
                    <Icon size={FontSizes[2]} src="HorizontalSlider" />
                </ToggleButton>
            </DarkTooltip>
            {openColumnSelection && (
                <ManagedTableSelectColumnsV2
                    anchorEl={anchorEl}
                    handleClose={showHideColumnHandleClose}
                />
            )}
        </>
    );
};
